import { useMemo } from 'react';
import { ethers } from 'ethers';
import { useWeb3 } from '../context/Web3Context';
import { CONTRACTS, EVITTA_ABI, ERC20_ABI } from '../config/contracts';

// Returns contract instances.
// - read*  : always available (uses signer if connected, else RPC provider)
// - write* : only when a valid signer exists (connected + correct network)
export function useContracts() {
  const { provider, readProvider, signer } = useWeb3();

  return useMemo(() => {
    const reader = provider || readProvider;

    const evittaRead =
      reader && CONTRACTS.evitta
        ? new ethers.Contract(CONTRACTS.evitta, EVITTA_ABI, reader)
        : null;
    const usdtRead =
      reader && CONTRACTS.usdt
        ? new ethers.Contract(CONTRACTS.usdt, ERC20_ABI, reader)
        : null;

    const evittaWrite = signer
      ? new ethers.Contract(CONTRACTS.evitta, EVITTA_ABI, signer)
      : null;
    const usdtWrite = signer
      ? new ethers.Contract(CONTRACTS.usdt, ERC20_ABI, signer)
      : null;

    return { evittaRead, usdtRead, evittaWrite, usdtWrite };
  }, [provider, readProvider, signer]);
}
